import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { DomainMappingPayload } from "../../shared/interfaces/DomainMappingPayload";

export function useDomainMappingsUpdate(callbacks?: {
  onError: (error: Response) => Promise<void>;
  onSuccess: () => void;
}) {
  const apiContext = useContext(ApiContext);
  return useMutation({
    ...callbacks,
    mutationKey: ["updateDomainMappings"],
    mutationFn: async (domainMappings: DomainMappingPayload) => {
      return await apiContext.domainMappingsApis.updateDomainMappings(domainMappings);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
